import React from 'react';
import TabRouting from '../../components/TabRouting';

const selectedMainTabIndex = 0;
const selectedSubTabIndex = 1;
const QuartileMain = () => {
    return <TabRouting selectedMainTabIndex={selectedMainTabIndex} selectedSubTabIndex={selectedSubTabIndex}></TabRouting>;
};

export default QuartileMain;
